@if (activeTemplate) {
  <ng-template *ngTemplateOutlet="activeTemplate"> </ng-template>
}

<ng-template #companyVerificationRequestStatusRejected>
  <rt-infobox
    [heading]="'app.spam_verification.infobox.rejected.heading' | translate"
    iconName="warning"
    type="error"
    [isDismissible]="false"
  >
    {{ 'app.spam_verification.infobox.rejected.content' | translate }}
  </rt-infobox>
</ng-template>

<ng-template #companyVerificationRequestStatusFormSubmitted>
  <rt-infobox
    [heading]="'app.spam_verification.infobox.submitted.heading' | translate"
    iconName="upgrade"
    type="warning"
    [isDismissible]="false"
  >
    {{ 'app.spam_verification.infobox.submitted.content' | translate }}
  </rt-infobox>
</ng-template>

<ng-template #companyVerificationRequestStatusApproved>
  <rt-infobox
    [heading]="'app.spam_verification.infobox.approved.heading' | translate"
    type="information"
    iconName="info-outline"
    storageKey="companyVerificationRequestStatusApproved"
  >
    {{ 'app.spam_verification.infobox.approved.content' | translate }}
  </rt-infobox>
</ng-template>
